"use client";

import { Loader2 } from "lucide-react";

/** 대시보드 위젯 공통 로딩 스피너(중앙 정렬 + a11y). 6개 위젯의 중복 제거(JCG-2073 코드리뷰). */
export default function DashboardCardLoading({
  height,
  label,
}: {
  height: number;
  label: string;
}) {
  return (
    <div
      className="flex items-center justify-center"
      style={{ height }}
      aria-live="polite"
      aria-busy="true"
    >
      <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" aria-label={label} />
    </div>
  );
}
